import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const OrgUnitAdminCredentialsSmallGrid = ({ gridData, isLoading, onDeleteCredentialClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>
            &nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>
              Loading...
            </div>
          </div>
        </div>
      ) : gridData.length > 0
        ? gridData.map((credential, i) => (
          <div className={global.SmallTableRow} key={credential.orgUnitNonAthleteEntryId || i}>
            <div className={global.SmallTableRowHead}><span className='hidden-xs'>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''}  ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : <span>&nbsp;</span>}</span>&nbsp;
              {onDeleteCredentialClicked && credential.hasPaid === false &&
                <button className={global.IconButton}
                  type="button"
                  onClick={(e) => onDeleteCredentialClicked(e, credential)}>
                  <DeleteIcon />
                </button>}
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className='row'>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Name</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''} ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Member Id</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.memberId || <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Email</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.email || <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>In Good Standing?</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.isInGoodStanding === true ? 'Yes' : credential.isInGoodStanding === false ? 'No' : <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Expiration Date</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.isInGoodStandingExpirationDate ? formatDate(credential.isInGoodStandingExpirationDate) : <span>&nbsp;</span>}</div>
                <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Credential</div>
                <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{credential.typeName || <span>&nbsp;</span>}</div>
              </div>
            </div>
          </div>
        )) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Credentials</div>
            </div>
          </div>
        )
    }
  </div >
);

export default OrgUnitAdminCredentialsSmallGrid;